import React, { useState, useEffect } from 'react';
import { apis } from '../../services/Api';
import { useLocation } from "react-router-dom";
import './CourseDetails.css';
// import thumb1 from '../../assets/images/bgimg.png'
import TimLine from '../../common/timeLine/timeLine';
import secondsToHms from '../../common/SecondsToHms/secondsToHms';

function CourseDetails(props) {

    let [courseDetails, setCourseDetails] = useState();
    let [learningObjectInstanceEnrollment, setLearningObjectInstanceEnrollment] = useState();
    let [coreContentCompleted, setCoreContentCompleted] = useState(0);
    let [coreContent, setCoreContent] = useState([]);
    let [learningObjectInstance, setLearningObjectInstance] = useState();
    const location = useLocation();

    useEffect(() => {
        async function apiCall() {
            let { data, included } = await apis.getLearningObject(props.history.location.state.cid);

            for (let i = 0; i < included.length; i++) {
                if (included[i].type === "learningObjectInstanceEnrollment") {
                    //console.log("learningObjectInstanceEnrollment");
                    setLearningObjectInstanceEnrollment(included[i]);
                }
            }
            setCourseDetails(data);
            let learningContent = [];
            let loResourcesData, totalCoreContentCompleted = 0;
            //? find learningObjectInstance
            for (let i = 0; i < included.length; i++) {
                if (included[i].type === "learningObjectInstance") {
                    //console.log("learningObjectInstance found");
                    loResourcesData = included[i].relationships.loResources.data;
                    setLearningObjectInstance(included[i]);
                    break;
                }
            }
            //console.log(loResourcesData);
            //? add meta data to learningObjectInstance
            for (let i = 0; i < loResourcesData.length; i++) {
                for (let y = 0; y < included.length; y++) {
                    if (loResourcesData[i].id === included[y].id) {
                        for (let a = 0; a < included.length; a++) {
                            if (included[y].relationships.resources.data[0].id === included[a].id) {
                                let tempLearningContent = {
                                    id: loResourcesData[i].id,
                                    name: included[a].attributes.name,
                                    duration: included[a].attributes.authorDesiredDuration,
                                    hasPassed: false
                                };
                                for (let z = 0; z < included.length; z++) {
                                    if ((included[z].type === "learningObjectResourceGrade") && (included[z].relationships.loResource.data.id === loResourcesData[i].id)) {
                                        tempLearningContent.hasPassed = included[z].attributes.hasPassed;
                                        if (included[z].attributes.hasPassed)
                                            totalCoreContentCompleted += 1;
                                        // setCoreContentCompleted(oldData => oldData + 1);
                                    }
                                }
                                // setCoreContent(oldData => [...oldData, tempLearningContent])
                                learningContent.push(tempLearningContent);
                            }
                        }
                    }
                }
            }
            // //console.log(learningContent);
            //add all learning content. do this way so that 
            //learning object is not going to push when page is re - farce 
            setCoreContent(learningContent);
            setCoreContentCompleted(totalCoreContentCompleted);
        }
        apiCall();
    }, [props.location.state.cid]);


    const playCourse = (cid, mid) => {
        props.history.push({
            pathname: `/course-player`,
            state: {
                cid,
                mid,
                goBackUrl: location.pathname
            }
        });
    }

    const enrollToCourse = async (cid, ciid) => {
        await apis.setEnrollment(cid, ciid);
        playCourse(cid);
    }


    const startUi = () => {
        //console.log(learningObjectInstanceEnrollment);
        if (learningObjectInstanceEnrollment && learningObjectInstanceEnrollment.attributes.progressPercent == 0) {
            return <button className="btn blue-btn" type="button" onClick={() => playCourse(courseDetails.id)}>Start</button>
        } else if (learningObjectInstanceEnrollment && learningObjectInstanceEnrollment.attributes.progressPercent > 0) {
            return <button className="btn blue-btn" type="button" onClick={() => playCourse(courseDetails.id)}>Continue</button>
        } else {
            return <button className="btn blue-btn" type="button" onClick={() => enrollToCourse(courseDetails.id, learningObjectInstance.id)}>Enroll</button>
        }
    }

    return (
        <React.Fragment>
            <div className='main-block'>
                <div className='container'>
                    <div className='heading'>
                        <h1>{courseDetails?.attributes.localizedMetadata[0].name}</h1>
                    </div>
                    <div className='wrapper'>
                        <div className='row'>
                            <div className='col-8'>
                                <p>{courseDetails?.attributes.localizedMetadata[0].overview}</p>
                                <div className='type-duration'>
                                    <span className='bold'>Format:</span>
                                    <span>&nbsp;{courseDetails?.attributes.loFormat}</span>
                                    {courseDetails?.attributes.duration > 1 &&
                                        <React.Fragment>
                                            <span className='small-separator'></span>
                                            <span className='bold'>Duration:</span>
                                            <span>&nbsp;{secondsToHms(courseDetails?.attributes.duration)}</span>
                                        </React.Fragment>
                                    }

                                </div>
                                <div className='type-duration'>
                                    {/* <span className='bold'>Author:</span>  <span>Sara Wilson</span> */}
                                </div>
                            </div>
                            <div className='col-4'>
                                <div className='img-progress-block'>
                                    <img src={courseDetails?.attributes.imageUrl} alt="featured image" />
                                    <div className="progress">
                                        <div className="progress-bar" role="progressbar" style={{ width: `${learningObjectInstanceEnrollment?.attributes.progressPercent > 92 ? '92' : learningObjectInstanceEnrollment?.attributes.progressPercent}%` }} aria-valuenow={learningObjectInstanceEnrollment?.attributes.progressPercent} aria-valuemin="0" aria-valuemax="100">
                                            <span style={{ left: `${learningObjectInstanceEnrollment?.attributes.progressPercent > 92 ? '92' : learningObjectInstanceEnrollment?.attributes.progressPercent}%` }}>{learningObjectInstanceEnrollment?.attributes.progressPercent || 0}%</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='text-btn'>
                                    <div className='txt'>
                                        {coreContentCompleted}/{coreContent.length} Trainings Completed
                                    </div>
                                    {startUi()}
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <nav>
                                    <div className="nav nav-tabs snip1168" id="nav-tab" role="tablist">
                                        <button className="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">
                                            <span>Modules</span>
                                        </button>
                                        <button className="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">
                                            <span>Notes</span>
                                        </button>
                                    </div>
                                </nav>
                                <div className="tab-content" id="nav-tabContent">
                                    <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                        <TimLine coreContent={coreContent} courseDetails={courseDetails} playCourse={playCourse} />
                                    </div>
                                    <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">...</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
export default CourseDetails;